import * as SchemaTypes from '../../../types.generated';

import { gql } from '@apollo/client';
import { UserManagementFragmentDoc } from '../../../fragments/user/generated/userManagementFragment';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UsersQueryVariables = SchemaTypes.Exact<{
  limit: SchemaTypes.Scalars['Int'];
  skip: SchemaTypes.Scalars['Int'];
  filter: SchemaTypes.UserFilterArgs;
}>;

export type UsersQuery = {
  __typename?: 'Query';
  users: {
    __typename?: 'PaginatedUserResponse';
    total: number;
    items: Array<{
      __typename?: 'User';
      id: string;
      deactivated?: boolean | null;
      lastActivityDate?: string | Date | null;
      role: SchemaTypes.Roles;
      email: string;
      profile: { __typename?: 'UserProfile'; fullName: string; phoneNumber?: string | null };
    }>;
  };
};

export const UsersDocument = gql`
  query Users($limit: Int!, $skip: Int!, $filter: UserFilterArgs!) {
    users(limit: $limit, skip: $skip, filter: $filter) {
      total
      items {
        ...UserManagement
      }
    }
  }
  ${UserManagementFragmentDoc}
`;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUsersQuery(baseOptions: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
}
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
}
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export function refetchUsersQuery(variables: UsersQueryVariables) {
  return { query: UsersDocument, variables: variables };
}
